import { useMutation } from '@tanstack/react-query'

import type { TCriarAtendimentoResponse } from '@/features/atendimento/interfaces'
import { CriarAtendimentoService } from '@/features/atendimento/services'
import { atendimentoKeys } from '@/features/atendimento/utils/queries'
import type { AxiosErrorMap } from '@/shared/lib/http/axios-adapter'

export const useCriarAtendimento = () => {
  return useMutation<TCriarAtendimentoResponse, AxiosErrorMap, string, unknown>({
    mutationKey: atendimentoKeys.criarAtendimento(),
    mutationFn: async (clienteId: string) => new CriarAtendimentoService().execute(clienteId),
  })
}
